import { CommonMessages } from "../messages/validationMessages"
import * as Yup from 'yup'

export const addDeviceIDSchema = Yup.object().shape({
    deviceId: Yup.string()
            .required(CommonMessages.select_deviceID_required)
            .notOneOf(['0'], CommonMessages.select_deviceID_required), // Disallow 0
})